const getters = {
  softCates : state => state.dataCache.softCates,
  guestbooks : state => state.dataCache.guestbooks,
  softList : state => state.dataCache.softList,

}
export default getters
